<template>
<div id="maintenance-msg">

	<div class="align-c">
		<h1 class="h1">Coming soon</h1>
		<p>Check back soon to see the new website.</p>
	</div>
			

</div>
</template>

<script>
import mixins from '.././mixins.js'


export default {
	
	mixins: [ mixins.generic ],
	
	components: { 		
		
	},

	data(){ return {
			

	}},

	computed: {

		

	},

	methods: {

		

	},

	mounted(){	
		document.documentElement.classList.add('page-maintenance')
	},

	destroyed(){		
		document.documentElement.classList.remove('page-maintenance')
	},

}
</script>



// WEBPACK FOOTER //
// src/views/Maintenance.vue